import { createSelector } from '@reduxjs/toolkit';

import { selectChatHeader } from '../chatHeaderSelector';

export const selectChatHeaderCard = createSelector(selectChatHeader, header => header?.card);
